import { EMPTY_OBJECT, getDateTime, shallowEqualsMemoizer } from '~/src/Lib/Utils'

export const percentageOfPhaseElapsed = shallowEqualsMemoizer((phase = EMPTY_OBJECT) => {
  const { startDate, endDate } = phase
  if (!startDate || !endDate) return '0%'
  const startDT = getDateTime(startDate)
  const endDT = getDateTime(endDate)
  const nowDT = getDateTime('now')
  if (nowDT < startDT) return '0%'
  if (nowDT > endDT) return '100%'
  const percentageElapsed = `${100 * ((nowDT - startDT) / (endDT - startDT))}%`
  return percentageElapsed
})
